<template>

<div class="container-fluid">
    <div class="container-fluid">
            <div class="row d-flex justify-content-between">
            <div class="col-8">
                <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="50"/></span>
                <span v-else><img src="@/assets/images/logo.png" height="50"/></span>
                <br>
                <h4 style="color:black" class="text-uppercase">{{ userData.business }}</h4>
                <span style="color:black;font-size:13px">Location : {{ userData.location }}</span><br>
                <span style="color:black;font-size:13px">Telephone : {{ userData.contact }}</span><br>
                <span style="color:black;font-size:13px">Email : {{ userData.email }}</span><br>
                <span style="color:black;font-size:13px">Website : {{ userData.website }}</span><br>
                <span v-if="userData.slogan" style="color:black;font-size:13px;font-style:italic">Slogan: {{ userData.slogan }}</span><br>
            </div>
            <div class="col-4">
                <!-- <img class="img-rounded" src="@/assets/images/sick.png" height="40px" /><br> -->
                <table v-for="item in patients" :key="item.id" class="table" density="compact" style="color:black">
                <img class="img-rounded" :src="getPhotos(item.photo)" height="40px" />
                <tr><td>Full Name</td><td> {{ item.name }}</td></tr>
                <tr><td>Gender</td><td> {{ item.gender }} </td></tr>
                <tr><td> Telephone </td><td> 0{{ item.telephone }} </td></tr>
                <tr><td> Age </td><td> {{ getAge(item.date_of_birth) }} yrs </td></tr>
                <tr><td> Address </td><td> {{ item.address }} </td></tr>
                </table>
            </div>
        </div>
    </div>
    <h6 class="mt-2 text-center">Date : {{ visit_date }}</h6>
    <h4 class="mt-2 text-center text-decoration-underline">Radiology Report</h4>
        <span v-html="diagnosis" style="line-height: 15px;" ></span>
        {{ date }}
    <div class="mt-3 text-center">
        <h5 style="color: black;" class="my-4 text-center">Signature : .........................</h5>
        <p style="color:black;font-size:13px">Printed by : {{ userData.username }} <br>  Via Afrimed Software | www.afrimed.com </p>
    </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  export default {
    data() {
      return {
        patients:[],
        patientspinner:true,
        userData: JSON.parse(localStorage.getItem("user")),
        patientid:'',
        visitid:'',
        service:'',
        service_id:'',
        recommedation:'',
        examination:'',
        history:'',
        service_category:[],
        service_name:[],
        service_price:'',
        patient_type:'1',
        date:'',
        diagnosis:'',
        treatmentresults:[],
        visit_date:"",
      };
    },
    created() {
      this.fetchInfo();
    },
    mounted() {
    setTimeout(() => {
        window.print();
        window.onafterprint=this.$router.go(-1);
    }, 5000);
    } ,
    methods: {
    //   getAge(dateString){
    //   let birth = new Date(dateString); let now = new Date(); let beforeBirth = ((() => {birth.setDate(now.getDate());birth.setMonth(now.getMonth()); return birth.getTime()})() < birth.getTime()) ? 0 : 1;
    //   return now.getFullYear() - birth.getFullYear() - beforeBirth;
    // },
    getAge(dateString) {
  let birth = new Date(dateString);
  let now = new Date();

  let years = now.getFullYear() - birth.getFullYear();
  let months = now.getMonth() - birth.getMonth();

  // Adjust years and months if the current month hasn't reached the birth month yet
  if (months < 0) {
    years--;
    months += 12;
  }

  // Adjust months if the current day hasn't reached the birth day yet
  if (now.getDate() < birth.getDate()) {
    months--;
    if (months < 0) {
      years--;
      months += 12;
    }
  }

  if (years > 0) {
    // return `${years} years and ${months} months old`;    

    return `${years} years `;

  } else {
    return `${months} months old`;
  }
},
     getFiles(name){
        let url = axios.defaults.baseURL;
        let imagelink = (url).slice(0,-3)+"logos/"+name;
        return imagelink;
      },
      getPhotos(name){
            let url = axios.defaults.baseURL;
            let imagelink = (url).slice(0,-3)+"patients/"+name;
            return imagelink;
          },
      async fetchInfo(){
        this.id=this.$route.query.id;
        let url = `/visitinfo/${this.id}`;
        await axios.get(url).then((response) => {
          this.patientid = response.data.visits[0].patient.patient_id;
          this.visitid = response.data.visits[0].visit_id;
          // this.service = response.data.visits[0].service_name.name;
          if (response.data.visits[0].service_name?.name) {
            this.service = response.data.visits[0].service_name.name;
        } else if (response.data.visits[0].insurance_service_name?.name) {
            this.service = response.data.visits[0].insurance_service_name.name;
        } 
          // this.service_id = response.data.visits[0].service_name.id;
          if (response.data.visits[0].service_name?.id) {
            this.service_id = response.data.visits[0].service_name.id;
        } else if (response.data.visits[0].insurance_service_name?.id) {
            this.service_id = response.data.visits[0].insurance_service_name.id;
        } 
          this.visit_date = response.data.visits[0].addedon;
          this.showpatient();
          this.showtreatments();
        });
      },
      async showpatient(){
        let url = `/patientprofile/${this.patientid}`;
        await axios.get(url).then((response) => {
          this.patients = response.data.patients;
          this.patientspinner=false;
        });
      },
      async showtreatments(){
        let url = `/profiletreatment/${this.patientid},${this.visitid},${this.service_id}`;
        await axios.get(url).then((response) => {
        if (response.data.treatments.length===0) {
          this.symptoms = '';
          this.history = '';
          this.examination = '';
          this.diagnosis = '';
          this.recommedation = '';
        }else{
          this.symptoms = response.data.treatments[0].symptoms;
          this.history = response.data.treatments[0].history;
          this.examination = response.data.treatments[0].examination;
          this.diagnosis = response.data.treatments[0].diagnosis;
          this.recommedation = response.data.treatments[0].recommedation;
          this.date = response.data.treatments[0].created_at;
        }
        });
      },
      
    },
  };
  </script>